import { defineMessage } from 'react-intl';
import { getDisplayInformation } from './get-display-information';

const unknownMarketplace = defineMessage({
  description: 'dataDrivenLogos.unknownMarketplace',
  defaultMessage: 'Unknown Marketplace',
  id: 'KtHZZi',
});

export const getMarketplaceDisplayName = (marketplaceId) => {
  const displayInformation =
    getDisplayInformation({
      marketplaceId: Number.parseInt(marketplaceId, 10),
    }) || {};
  if (displayInformation.name) {
    // Return inline message descriptor to avoid formatjs/no-useless-message lint error
    return { id: 'marketplace.dynamic', defaultMessage: displayInformation.name };
  }
  return unknownMarketplace;
};
